<template>
  <a
    v-if="href"
    :class="componentClasses"
    :href="disabled ? undefined : href"
    :title="title"
    :aria-disabled="disabled || undefined"
    @click="handleClick"
  >
    <i :class="icon" />
  </a>
  <button
    v-else
    :class="componentClasses"
    :disabled="disabled"
    :title="title"
    @click="handleClick"
  >
    <i :class="icon" />
  </button>
</template>

<script setup>
import { computed } from 'vue';

const emit = defineEmits(['click']);

const props = defineProps({
  icon: {
    type: String,
    default: 'fas fa-chevron-down',
  },
  href: {
    type: String,
    default: '',
  },
  title: {
    type: String,
    default: '',
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  inherit: {
    type: Boolean,
    default: false,
  },
});

function handleClick(event) {
  if (props.disabled) {
    event.preventDefault();
    return;
  }
  emit('click', event);
}

const componentClasses = computed(() => [
  'stk-icon is-button',
  props.inherit || 'primary-color',
  props.inherit && 'inherit-color',
]);
</script>

<style>
.stk-icon.is-button {
  cursor: pointer;
  text-decoration: none;

  &[disabled],
  &[aria-disabled='true'] {
    box-shadow: none;
    opacity: 0.5;
    pointer-events: none;
  }

  &.primary-color {
    color: var(--stk-primary);
  }
}
</style>
